/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': '轉角',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text': '搜尋經過驗證的公告、資源和政策',
  'company-hub.search-extension.custom-search-config-panel.filters-title': '篩選條件',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': '預留位置文字',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label': '自訂讀者會看到的提示',
  'company-hub.search-extension.custom-search-config-panel.preamble': '新增經過篩選的搜尋列',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': '圓形',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': '正方形',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': '填入顏色',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': '文字顏色',
  'company-hub.search-extension.custom-search-config-panel.styles-title': '樣式',
  'company-hub.search-extension.custom-search-config-panel.title': '自訂搜尋',
  'company-hub.search-extension.manifest.default-placeholder-text': '搜尋經過驗證的公告、資源和政策',
  'company-hub.search-extension.manifest.macro-description': '新增經過篩選的搜尋列',
  'company-hub.search-extension.manifest.macro-title': '自訂搜尋',
  'company-hub.search-extension.more-button': '檢視更多結果',
};
